module.exports = __webpack_public_path__ + "static/media/renu3.da6be233.png";